// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   CustomInput,
//   FormFieldSet,
//   InfoTimeCardAdv,
//   NewTable,
//   PageHeader,
//   PageTitle,
//   useFormHandler,
// } from "../../../../../../components";
// import {
//   DeductionName,
//   deductionoprtions,
//   PaymentTypeoprtions,
//   startcycleopetion,
// } from "../../../../../../assets/data/projectData";
// import { mapTableRows } from "../../../../../../utils";
// import ReceivePayments from "./Modals/ReceivePayments";

// const CollapseFromComponent = ({ uniqueId,rowData, setActiveTab }) => {
//   console.log("rowData",rowData);
//   const componentId = uniqueId || Math.random().toString(36).substring(2, 9);
//   const [receivePayment, setReceicePayent] = useState(false);
//   const { formData, errors, handleChange, validateAllFields } = useFormHandler({
//     deductionType: "",
//     deductionName: "",
//     payDate: "",
//     retailInvoiceNumber: "",
//     // invoiceNumber: "",
//     attachment: [],
//     // onvoiceAttachment: [],
//     deductionAmount: "",
//     paymentType: "Not To Detect",
//     deductionTypeRadio: "Pre-Tax Deduction",
//     modeofDeduction: "Parallel Deduction",
//     // comments: "",
//     startCycle: "",
//     instalments: "",
//     numberOfInstallments: "",
//   });

//   const [tableData, setTableData] = useState([
//     {
//       id: 1,
//       schedule: "schedule 1",
//       payCycle: "01/01/2024-01/31/2024",
//       amountReceived: "700",
//       receivedAmount: "700",
//       comments: "",
//     },
//     {
//       id: 2,
//       schedule: "schedule 2",
//       payCycle: "01/01/2024-01/31/2024",
//       amountReceived: "700",
//       receivedAmount: "700",
//       comments: "",
//     },
//     {
//       id: 3,
//       schedule: "schedule 3",
//       payCycle: "01/01/2024-01/31/2024",
//       amountReceived: "700",
//       receivedAmount: "700",
//       comments: "",
//     },
//   ]);

//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const advancePaymentsColumns = [
//     {
//       key: "schedule",
//       label: "Schedule",
//     },
//     { key: "payCycle", label: "Pay Cycle" },

//     { key: "amountReceived", label: "Amount Received" },
//     { key: "receivedAmount", label: "Received Amount" },
//     {
//       key: "comments",
//       label: "Comments",
//       render: (row) => (
//         <div>
//           <CustomInput
//             type="text"
//             placeholder=""
//             title=""
//             size={"xs"}
//             value={row?.comments}
//             onChange={(e) => handleChangeTable("comments", row, e)}
//           />
//         </div>
//       ),
//     },
//   ];
//   //   const mappedRows = mapTableRows(tableData, advancePaymentsColumns);
//   const installmentTableData = [
//     {
//       id: 1,
//       schedule: "schedule 1",
//       payCycle: "01/01/2024-01/31/2024",
//       amountReceived: "500",
//     },
//     {
//       id: 2,
//       schedule: "schedule 2",
//       payCycle: "01/01/2024-01/31/2024",
//       amountReceived: "500",
//     },
//     {
//       id: 3,
//       schedule: "schedule 3",
//       payCycle: "01/01/2024-01/31/2024",
//       amountReceived: "500",
//     },
//     {
//       id: 4,
//       schedule: "schedule 4",
//       payCycle: "01/01/2024-01/31/2024",
//       amountReceived: "500",
//     },
//     {
//       id: 5,
//       schedule: "schedule 5",
//       payCycle: "01/01/2024-01/31/2024",
//       amountReceived: "500",
//     },
//   ];

//   const installmentColumns = [
//     {
//       key: "schedule",
//       label: "Schedule",
//     },
//     { key: "payCycle", label: "Pay Cycle" },

//     { key: "amountReceived", label: "Amount Received" },
//   ];
//   const installmetRows = mapTableRows(installmentTableData, installmentColumns);

//   const handleChangeTable = (field, row, value) => {
//     setTableData((prev) =>
//       prev.map((item) =>
//         item.id === row.id ? { ...item, [field]: value } : item
//       )
//     );
//   };
//   useEffect((rowData)=>{

//   })
//   return (
//     <div className="p-3">
//       <div className="grid grid-cols-3 gap-x-6 gap-y-6 px-2 max-w-7xl">
//         <FormFieldSet
//           type="select"
//           title="Deduction Type"
//           placeholder="Select Deduction Type"
//           value={formData.deductionType}
//           onChange={(value) => handleChange("deductionType", value)}
//           error={errors.deductionType}
//           // showButton
//           options={deductionoprtions}
//           // showSearch
//         />
//         <FormFieldSet
//          type="deductions"
//           title="Deduction Name"
//           placeholder="Select Deduction Name"
//           value={formData.deductionName}
//           onChange={(value) => handleChange("deductionName", value)}
//           error={errors.deductionName}
//           // options={DeductionName}
//            showButton
//           showSearch
//         />
//         <FormFieldSet
//           type="datepicker"
//           title="Pay Date"
//           placeholder="Select Pay Date"
//           value={formData.payDate}
//           onChange={(value) => handleChange("payDate", value)}
//           error={errors.payDate}
//         />

//         <FormFieldSet
//           type="text"
//           title="Retail Invoice Number"
//           placeholder="Enter Retail Invoice Number"
//           value={formData.retailInvoiceNumber}
//           onChange={(value) => handleChange("retailInvoiceNumber", value)}
//           error={errors.retailInvoiceNumber}
//         />

//         <FormFieldSet
//           type="file"
//           title={"Attachment"}
//           placeholder="Choose File"
//           value={formData.attachment}
//           onChange={(value) => handleChange("attachment", value)}
//           error={errors.attachment}
//         />

//         <FormFieldSet
//           type="text"
//           title="Deduction Amount"
//           placeholder="Enter Deduction Amount"
//           value={formData.deductionAmount}
//           onChange={(value) => handleChange("deductionAmount", value)}
//           error={errors.deductionAmount}
//         />
//         <FormFieldSet
//           type="select"
//           title="Payment Type"
//           placeholder="Select Payment Type"
//           value={formData.paymentType}
//           onChange={(value) => handleChange("paymentType", value)}
//           error={errors.paymentType}
//           options={PaymentTypeoprtions}
//         />
//         <FormFieldSet
//           type="select"
//           title="Start Cycle"
//           placeholder="selectStart Cycle"
//           value={formData.startCycle}
//           onChange={(value) => handleChange("startCycle", value)}
//           error={errors.startCycle}
//           options={startcycleopetion}
//         />
//         <div>
//           <span className="text-[12px] font-medium mb-0.5 ">installments </span>
//           <div className="p-1 border-[1px] border-neutrals-200 max-h-32 overflow-auto">
//             <NewTable
//               columns={installmentColumns}
//               rows={installmetRows}
//               hideToolBar
//             />
//           </div>
//         </div>
//         <FormFieldSet
//           type="radio"
//           title="Deduction Type"
//           placeholder="Deduction Type"
//           options={[
//             { label: "Pre-Tax Deduction", value: "Pre-Tax Deduction" },
//             { label: "Post-Tax Deduction", value: "Post-Tax Deduction" },
//           ]}
//           value={formData.deductionTypeRadio}
//           onChange={(event) =>
//             handleChange("deductionTypeRadio", event.target.value)
//           }
//           //   name="Deduction Type"
//           //   name={`deductionTypeRadio-${uniqueId}`}
//           name={`deductionTypeRadio-${componentId}`} //
//         />

//         <FormFieldSet
//           type="radio"
//           title="Mode of Deduction"
//           placeholder="Select Mode"
//           options={[
//             { label: "Parallel Deduction", value: "Parallel Deduction" },
//             { label: "One after another", value: "One after another" },
//           ]}
//           value={formData.modeofDeduction}
//           onChange={(event) =>
//             handleChange("modeofDeduction", event.target.value)
//           }
//           error={errors.modeofDeduction}
//           //   name="Mode of Deduction"
//           //   name={`modeofDeduction-${uniqueId}`}
//           name={`modeofDeduction-${componentId}`}
//         />

//         <FormFieldSet
//           type="textArea"
//           title="Comments"
//           placeholder="Enter Comments"
//           value={formData.comments}
//           onChange={(value) => handleChange("comments", value)}
//           error={errors.comments}
//         />
//       </div>
//       <PageHeader
//         RightSection={
//           <div className="my-2 flex gap-3 items-end">
//             <div >

//               <Button
//                 title="Save"
//                 color="info"
//                 // onClick={() => setReceicePayent(true)}
//               />

//             </div>
//             <div><Button
//                 title="Receive Payment"
//                 color="info"
//                 onClick={() => setReceicePayent(true)}
//               /></div>

//             <div className="flex gap-3">
//               <InfoTimeCardAdv
//                 title="installments"
//                 value="10/12"
//                 color="primary"
//               />
//               <InfoTimeCardAdv
//                 title="Remaining amount"
//                 value="91000"
//                 color="primary"
//               />
//             </div>
//           </div>
//         }
//       />
//       <div className="my-3">
//         <NewTable
//           columns={advancePaymentsColumns}
//           rows={tableData}
//           hideToolBar
//         />
//       </div>
//       <ReceivePayments
//         isOpen={receivePayment}
//         onClose={() => setReceicePayent(false)}
//         setActiveTab={setActiveTab}
//         shouldMoveTab={true}
//       />
//     </div>
//   );
// };

// export default CollapseFromComponent;

import React, { useEffect, useState } from "react";
import {
  Button,
  CustomInput,
  FormFieldSet,
  InfoTimeCardAdv,
  NewTable,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../components";
import {
  DeductionName,
  deductionoprtions,
  PaymentTypeoprtions,
  startcycleopetion,
} from "../../../../../../assets/data/projectData";
import { mapTableRows } from "../../../../../../utils";
import ReceivePayments from "./Modals/ReceivePayments";
import dayjs from "dayjs";
import common from "../../../../../../utils/common";
import { dateFormator, exactUTCDate } from "../../../../../../utils/dateFormator";
import { formatCurrency } from "../../../../../../utils/stringUtils";

const CollapseFromComponent = ({ uniqueId, rowData = null, setActiveTab }) => {
  console.log("rowData", rowData);
  const { generateMonthStartToEnd, formatDate } = common;
  const componentId = uniqueId || Math.random().toString(36).substring(2, 9);
  const [receivePayment, setReceicePayent] = useState(false);
  const defaultValue = {
    deductionType: "",
    deductionName: "",
    payDate: "",
    retailInvoiceNumber: "",
    invoiceNumber: "",
    attachment: [],
    onvoiceAttachment: [],
    deductionAmount: "",
    paymentType: 1,
    deductionTypeRadio: 1,
    modeofDeduction: 1,
    comments: "",
    startCycle: "",
    endCycle: "",
    instalments: "",
    numberOfInstallments: "",
  };
  const [updateRoles, setUpdateRoles] = useState({
    deductionType: { type: "select", required: true },
    deductionName: { type: "select", required: true },
    paymentType: { type: "select", required: true },
    deductionAmount: { type: "text", required: true, number: true },
    attachment: { type: "file" },
    onvoiceAttachment: { type: "file" },
  });
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    defaultValue,
    updateRoles
  );
  useEffect(() => {
    if (formData.paymentType === 1) {
      const rules = {
        ...updateRoles,
        numberOfInstallments: { type: "text", required: true, number: true },
      };
      setUpdateRoles(rules);
    }
  }, [formData.paymentType]);
  const [startCycles, setStartCycles] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [summary, setSummary] = useState({ installments: "0/0", remaining: 0 });
  const [isEditable, setIsEditable] = useState(false);

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
    }
  };

  const advancePaymentsColumns = [
    {
      key: "schedule",
      label: "Schedule",
    },
    {
      key: "payCycle",
      label: "Pay Cycle",
      render: (row) => {
        const from = row?.payCycle?.from;
        const to = row?.payCycle?.to;
        return (
          <div>
            {exactUTCDate(from)} - {exactUTCDate(to)}
            {/* {dateFormator(from)} - {dateFormator(to)}*/}
          </div>
        );
      },
    },
    {
      key: "payMethod",
      label: "Pay Cycle",
      render: (row) => {
        return <div>Payment Received From {row?.payMethod}</div>;
      },
    },

    { key: "receivable", label: "Amount Receivable", render: (row) => formatCurrency(row?.receivable) },
    { key: "received", label: "Received Amount", render: (row) => formatCurrency(row?.received) },
    {
      key: "comments",
      label: "Comments",
      render: (row) => (
        <div>
          <CustomInput
            type="text"
            placeholder=""
            title=""
            size={"xs"}
            value={row?.comments}
            onChange={(e) => handleChangeTable("comments", row, e)}
          />
        </div>
      ),
    },
  ];
  //   const mappedRows = mapTableRows(tableData, advancePaymentsColumns);

  const installmentColumns = [
    {
      key: "schedule",
      label: "Schedule",
    },
    {
      key: "payCycle",
      label: "Pay Cycle",
      render: (row) => {
        const from = row?.payCycle?.from;
        const to = row?.payCycle?.to;
        return (
          <div>
            {exactUTCDate(from)} - {exactUTCDate(to)}
          </div>
        );
      },
    },
    { key: "receivable", label: "Amount Receivable", render: (row) => formatCurrency(row?.receivable) },
  ];
  const installmetRows = mapTableRows(tableData, installmentColumns);

  const handleChangeTable = (field, row, value) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [field]: value } : item
      )
    );
  };
  useEffect(() => {
    const editable = !!rowData;

    if (editable) {
      console.log("rowData", rowData);
      handleChange("deductionName", rowData?.name);
      handleChange("deductionAmount", `${rowData?.amounts?.deducted}`);
      handleChange("deductionType", rowData?.deductionType);
      handleChange("payDate", rowData?.payDate);
      handleChange("paymentType", rowData?.payType);
      handleChange("retailInvoiceNumber", rowData?.retailInvNum);
      handleChange("comments", rowData?.comments);
      handleChange("deductionTypeRadio", rowData?.taxType);
      handleChange("modeofDeduction", rowData?.mode);
      handleChange("numberOfInstallments", `${rowData?.installmentNum}`);
      if (rowData?.endCycle) {
        handleChange("endCycle", rowData?.endCycle);
      }
      if (rowData?.startCycle?.from && rowData?.startCycle?.to) {
        const startDate = dayjs.utc(rowData.startCycle.from);
        const endDate = dayjs.utc(rowData.startCycle.to);
        console.log({startDate,endDate})

        const start = startDate.format("MM/DD/YYYY");
        const end = endDate.format("MM/DD/YYYY");
        // const start = exactUTCDate(startDate);
        // const end = exactUTCDate(endDate);

        // const nextMonthStart = new Date(
        //   startDate.getFullYear(),
        //   startDate.getMonth() + 1,
        //   1
        // );
        const nextMonthStart = startDate.add(1, "month").startOf("month");
        const startCycleString = `${start} - ${end}`;
        handleChange("startCycle", startCycleString);
        setStartCycles([
          // { label: start, value: end },
          // { label: startCycleString, value: startCycleString },
          ...generateMonthStartToEnd(nextMonthStart, 2),
        ]);
        console.log("start Cycle for options", [
          { label: start, value: end },
          ...generateMonthStartToEnd(nextMonthStart, 2),
        ]);
      }
      if (rowData?.installments) {
        // console.log("rowData?.installments for amunts", rowData);
        setTableData(rowData?.installments || []);
        setSummary({
          installments: `${
            rowData?.installments.filter(
              (data) => !data.receivable || data.receivable === 0 || data.receivable === data.received
            ).length
          }/${rowData?.installments.length}`,
          remaining:
            (rowData?.amounts?.deducted || 0) -
            (rowData?.amounts?.received || 0),
        });
      }
    }
  }, [rowData, isEditable]);
  console.log("deductionTypeRadio", formData?.deductionTypeRadio);
  return (
    <div className="p-3">
      <div className="grid grid-cols-3 gap-x-6 gap-y-6 px-2 max-w-7xl">
        <FormFieldSet
          type="select"
          title="Deduction Type"
          placeholder="Select Deduction Type"
          value={formData.deductionType}
          onChange={(value) => handleChange("deductionType", value)}
          error={errors.deductionType}
          // showButton
          options={deductionoprtions}
          // showSearch
          disabled={!isEditable}
        />
        <FormFieldSet
          // type="select"
          type="deductions"
          title="Deduction Name"
          placeholder="Select Deduction Name"
          value={formData.deductionName}
          onChange={(value) => handleChange("deductionName", value)}
          error={errors.deductionName}
          showButton
          showSearch
          disabled={!isEditable}
          // options={DeductionName}
        />
        {formData?.deductionType !== 2 && (
          <FormFieldSet
            type="datepicker"
            title="Pay Date"
            placeholder="Select Pay Date"
            value={formData.payDate}
            onChange={(value) => handleChange("payDate", value)}
            error={errors.payDate}
            disabled={!isEditable}
            showDropdown={false}
          />
        )}

        {formData.paymentType == 3 ? (
          <>
            {formData?.deductionType !== 2 && (
              <FormFieldSet
                type="text"
                title="Invoice Number"
                placeholder="Enter Invoice Number"
                value={formData.retailInvoiceNumber}
                onChange={(value) => handleChange("retailInvoiceNumber", value)}
                error={errors.retailInvoiceNumber}
                disabled={!isEditable}
              />
            )}
          </>
        ) : (
          <>
            {formData?.deductionType !== 2 && (
              <FormFieldSet
                type="text"
                title="Retail Invoice Number"
                placeholder="Enter Retail Invoice Number"
                value={formData.retailInvoiceNumber}
                onChange={(value) => handleChange("retailInvoiceNumber", value)}
                error={errors.retailInvoiceNumber}
                disabled={!isEditable}
              />
            )}
          </>
        )}

        {formData.paymentType == 3 ? (
          <>
            {formData?.deductionType !== 2 && (
              <FormFieldSet
                type="file"
                title={"Invoice Attachment"}
                placeholder="Choose File"
                value={formData.attachment}
                onChange={(value) => handleChange("attachment", value)}
                error={errors.attachment}
                multiple
                disabled={!isEditable}
              />
            )}
          </>
        ) : (
          <>
            {formData?.deductionType !== 2 && (
              <FormFieldSet
                type="file"
                title={"Attachment"}
                placeholder="Choose File"
                value={formData.attachment}
                onChange={(value) => handleChange("attachment", value)}
                error={errors.attachment}
                multiple
                disabled={!isEditable}
              />
            )}
          </>
        )}

        <FormFieldSet
          type="text"
          title="Deduction Amount"
          placeholder="Enter Deduction Amount"
          value={formData.deductionAmount}
          onChange={(value) => handleChange("deductionAmount", value)}
          error={errors.deductionAmount}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="select"
          title="Payment Type"
          placeholder="Select Payment Type"
          value={formData.paymentType}
          onChange={(value) => handleChange("paymentType", value)}
          error={errors.paymentType}
          options={PaymentTypeoprtions}
          disabled={!isEditable}
        />
        {formData.paymentType === 2 && (
          <>
            <FormFieldSet
              type="select"
              title="Start Cycle"
              placeholder="selectStart Cycle"
              value={formData.startCycle}
              onChange={(value) => handleChange("startCycle", value)}
              error={errors.startCycle}
              options={startCycles}
              disabled={!isEditable}
            />
            {/* <div></div> */}
            <FormFieldSet
              type="text"
              title="Number of Installments"
              placeholder="Enter Number of Installments"
              value={formData.numberOfInstallments}
              onChange={(value) => handleChange("numberOfInstallments", value)}
              error={errors.numberOfInstallments}
              disabled={!isEditable}
            />
            <div className="p-1 border-[1px] border-neutrals-200 max-h-[40vh] overflow-auto col-span-3">
              <NewTable
                columns={installmentColumns}
                rows={installmetRows}
                hideToolBar
              />
            </div>
            {/* <div></div> */}
          </>
        )}
        {formData.paymentType === 3 && (
          <>
            <FormFieldSet
              type="datepicker"
              title="End Cycle"
              placeholder="Select End Cycle Date"
              value={formData.endCycle}
              onChange={(value) => handleChange("endCycle", value)}
              error={errors.endCycle}
              minDate={dayjs().startOf("day")}
              disabled={!isEditable}
              showDropdown={false}
            />
            {/* <FormFieldSet
                              type="textArea"
                              title="Installments"
                              placeholder="Enter Number of Installments"
                              value={formData.instalments}
                              onChange={(value) => handleChange("instalments", value)}
                              error={errors.instalments}
                            /> */}
            <div className="p-1 border-[1px] border-neutrals-200 max-h-[40vh] overflow-auto col-span-3">
              <NewTable
                columns={installmentColumns}
                rows={installmetRows}
                hideToolBar
              />
            </div>
            {/* <div></div> */}
          </>
        )}
        <div className="grid grid-cols-1 ">
          <FormFieldSet
            type="radio"
            title="Tax Deduction"
            placeholder="Deduction Type"
            options={[
              { label: "Pre-Tax Deduction", value: 1 },
              { label: "Post-Tax Deduction", value: 2 },
            ]}
            value={formData.deductionTypeRadio}
            onChange={(event) =>
              handleChange("deductionTypeRadio", event.target.value)
            }
            //   name="Deduction Type"
            //   name={`deductionTypeRadio-${uniqueId}`}
            name={`deductionTypeRadio-${componentId}`} //
            disabled={!isEditable}
          />
        </div>
        <div className="grid grid-cols-1 col-span-2 ">
          <FormFieldSet
            type="radio"
            title="Mode of Deduction"
            placeholder="Select Mode"
            options={[
              { label: "Parallel Deduction", value: 1 },
              { label: "One after another", value: 2 },
            ]}
            value={formData.modeofDeduction}
            onChange={(event) =>
              handleChange("modeofDeduction", event.target.value)
            }
            error={errors.modeofDeduction}
            //   name="Mode of Deduction"
            //   name={`modeofDeduction-${uniqueId}`}
            name={`modeofDeduction-${componentId}`}
            disabled={!isEditable}
          />
        </div>
        <div className="col-span-3">
          <FormFieldSet
            type="textArea"
            title="Comments"
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
            disabled={!isEditable}
          />
        </div>
      </div>
      <PageHeader
        RightSection={
          <div className="my-2 flex gap-3 items-end">
            {isEditable && (
              <Button title="Save" color="info" onClick={() => handleSave()} />
            )}
            <Button
              title={isEditable ? "Cancel" : "Edit"}
              color="primary"
              variant={"outlined"}
              onClick={() => setIsEditable(!isEditable)}
            />
            <div>
              <Button
                title="Receive Payment"
                color="primary"
                onClick={() => setReceicePayent(true)}
              />
            </div>

            <div className="flex gap-3">
              <InfoTimeCardAdv
                title="Installments"
                value={summary.installments}
                color="primary"
              />
              <InfoTimeCardAdv
                title="Remaining amount"
                value={formatCurrency(summary.remaining)}
                color="primary"
              />
            </div>
          </div>
        }
      />
      <div className="my-3">
        <NewTable
          columns={advancePaymentsColumns}
          // rows={tableData.filter((list) => list.receivable >= list.received)}
          rows={tableData}
          hideToolBar
        />
      </div>
      <ReceivePayments
        isOpen={receivePayment}
        onClose={() => setReceicePayent(false)}
        setActiveTab={setActiveTab}
        shouldMoveTab={true}
      />
    </div>
  );
};

export default CollapseFromComponent;
